import { get } from 'es-toolkit/compat';
export default get;
